"use strict";
angular.module('manageSysManageXHContributionAccessRecordsRouterModule', []).
config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("manageconfig.sysmanage.XHContributionAccessRecords.mediaNameDetail", { // 媒体名称详情
        url: '/mediaNameDetail?NAME&BeginDate&EndDate',
        views: {
            'main@manageconfig.sysmanage': {
                templateUrl: './manageConfig/sysManageMent/XHContributionAccessRecords/mediaNameDetail/mediaNameDetail_tpl.html',
                controller: 'manageSysManageMediaNameDetailCtrl'
            }
        }
    });
}]);
